module.exports = __webpack_public_path__ + "media/country_flags/dk-5d340061.png";